export default __webpack_public_path__ + "static/media/ReleaseNotes_Content_BrokerNotes3.d4791840.png";